export const actionTypes = {
  GET_DATA: 'TAPS.3NDFL.XML.VIEW.GET_DATA',
  GET_DATA_SUCCESS: 'TAPS.3NDFL.XML.VIEW.GET_DATA_SUCCESS',
  GET_DATA_FAILURE: 'TAPS.3NDFL.XML.VIEW.GET_DATA_FAILURE',
  COPY: 'TAPS.3NDFL.XML.VIEW.COPY',
  COPY_SUCCESS: 'TAPS.3NDFL.XML.VIEW.COPY_SUCCESS',
  COPY_FAILURE: 'TAPS.3NDFL.XML.VIEW.COPY_FAILURE',
  RE_SEND: 'TAPS.3NDFL.XML.VIEW.RE_SEND',
  RE_SEND_SUCCESS: 'TAPS.3NDFL.XML.VIEW.RE_SEND_SUCCESS',
  RE_SEND_FAILURE: 'TAPS.3NDFL.XML.VIEW.RE_SEND_FAILURE',
  RESET_COPY_DATA: 'TAPS.3NDFL.XML.VIEW.RESET_COPY_DATA',
};

const getData = (data) => {
  return {
    type: actionTypes.GET_DATA,
    payload: data,
  };
};

const getDataSuccess = (data) => {
  return {
    type: actionTypes.GET_DATA_SUCCESS,
    payload: data,
  };
};

const getDataFailure = (error) => {
  return {
    type: actionTypes.GET_DATA_FAILURE,
    payload: error,
  };
};

const copy = (cardId) => {
  return {
    type: actionTypes.COPY,
    payload: cardId,
  };
};

const copySuccess = (cardId) => {
  return {
    type: actionTypes.COPY_SUCCESS,
    payload: cardId,
  };
};

const copyFailure = (error) => {
  return {
    type: actionTypes.COPY_FAILURE,
    payload: error,
  };
};

const reSend = (cardId) => {
  return {
    type: actionTypes.RE_SEND,
    payload: cardId,
  };
};

const reSendSuccess = (cardId) => {
  return {
    type: actionTypes.RE_SEND_SUCCESS,
    payload: cardId,
  };
};

const reSendFailure = (error) => {
  return {
    type: actionTypes.RE_SEND_FAILURE,
    payload: error,
  };
};
const resetCopyData = () => {
  return {
    type: actionTypes.RESET_COPY_DATA,
  };
};

export {
  getData,
  getDataSuccess,
  getDataFailure,
  copy,
  copySuccess,
  copyFailure,
  reSend,
  reSendSuccess,
  reSendFailure,
  resetCopyData,
};
